<template>
  <div>
    <TruckBookings v-if="isAdmin"></TruckBookings>
  </div>
</template> 

<script>
import TruckBookings from "@/components/bookings/admin/TruckBookings";
export default {
  name: 'AdminTruckBookings',
  components: { TruckBookings },
  data() {
    return {}
  },
  computed: {
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    }
  }
}
</script>

<style lang="scss" scoped>

</style>